import { Field } from "@/modules/Forms/models/Field";
import { FormSchema } from "@/shared/models/FormSchema";
import { FieldSummary } from "./FieldSummary";
import { FormRule } from "./FormRule";

export class FormTemplateData {
  name!: string;
  type!: string;
  category!: string;
  version!: number;
  state!: string;
  schema!: FormSchema;
  fields!: Field[];
  dateCreated?: number;
  dateChanged?: number;
  formRules!: FormRule[];
  formSummary!: FieldSummary[];
  partialSave!: boolean;
}
